/**
 * Created by Administrador on 18/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('aircraftList', {
                parent: 'app',
                url: '/aircraft/list',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/aircraft/aircraft/aircrafts.html',
                        controller: 'aircraftCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAircrafts('aircraftList');
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircraft']);
                            }],
                            aircrafts: ['aircraftService', '$stateParams', function (aircraftService, $stateParams) {
                                return aircraftService.getPageAircrafts($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('aircraftNew', {
                parent: 'app',
                url: '/aircraft/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/aircraft/aircraft/newAircraft.html',
                        controller: 'newAircraftCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            tabs: ['tabService', function(tabService){
                                return tabService.getTabAircrafts('aircraftList');
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircraft']);
                            }],
                            modelAircrafts: ['modelAircraftService', function(modelAircraftService) {
                                return modelAircraftService.getModelAircraftsJoinStructures();
                            }],
                            fuelTypes: ['fuelTypeService', function(fuelTypeService) {
                                return fuelTypeService.getFuelTypes();
                            }],
                            aircraft: [function() {
                                return {
                                    plaque: "",
                                    cargo: false,
                                    passenger: false,
                                    structureId: 0,
                                    fuelTypeId: 0
                                };
                            }]
                        }
                    }
                }
            })
            .state('aircraftEdit', {
                parent: 'app',
                url: '/aircraft/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/aircraft/aircraft/editAircraft.html',
                        controller: 'editAircraftCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            tabs: ['tabService', function(tabService){
                                return tabService.getTabAircrafts('aircraftList');
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircraft']);
                            }],
                            modelAircrafts: ['modelAircraftService', function(modelAircraftService) {
                                return modelAircraftService.getModelAircraftsJoinStructures();
                            }],
                            fuelTypes: ['fuelTypeService', function(fuelTypeService) {
                                return fuelTypeService.getFuelTypes();
                            }],
                            aircraft: ['aircraftService','$stateParams', function(aircraftService,$stateParams) {
                                return aircraftService.getAircraft($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('aircraftDelete', {
                parent: 'aircraftList',
                url: '/aircraft/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/aircraft/aircraft/deleteAircraft.html',
                        controller: 'deleteAircraftCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircraft']);
                            }],
                            'aircraft': ['aircraftService', function(aircraftService) {
                                return aircraftService.getAircraft($stateParams.id);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('aircraftList', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }
})();
